// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
import "flatpickr/dist/themes/material_green.css";
// COMPONENTS
import InputMask from 'react-input-mask';
import Flatpickr from "react-flatpickr";
import { Link } from 'react-router-dom';
// ICONS
import { AiOutlineLoading } from 'react-icons/ai';
import { CgClose } from 'react-icons/cg';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';

const InputBlock = (props) => {

    const errorMessageSuffix = "is required";
    const inputStates = {
        error: "error",
        warning: "warning",
        success: "success",
        disabled: "disabled"
    }

    const marginTop = () => {
        if (props.inputLabel) {
            return 25
        } else if (props.label) {
            return 35
        } else {
            return 10
        }
    }

    return (
        <>
            <CustomBlock className={`input-block-container ${props.containerClassName ? props.containerClassName : ""}`}>
                {
                    props.inputLabel &&
                    <span className={`static-floating-label ${props.inputState}`}>
                        {props.inputLabel}{props.isRequired && <span className="danger--clr fw-600">*</span>}
                    </span>
                }
                {
                    props.label &&
                    <span className={`static-label ${props.inputState}`}>
                        {props.label}{props.isRequired && <span className="danger--clr fw-600">*</span>}
                    </span>
                }
                <CustomBlock>
                    <CustomBlock className="icon-left-container" style={{ marginTop: marginTop() }}>
                        <button
                            type="button"
                            tabIndex="-1"
                            onClick={props.iconLeftOnClick ? props.iconLeftOnClick : () => { }}
                        >
                            {props.iconLeft}
                        </button>
                    </CustomBlock>

                    {
                        props.type === 'date' ?
                            <Flatpickr
                                {...props}
                                className={`input-block ${props.className ? props.className : ""} ${props.backgroundColor ? props.backgroundColor : "light--sbg"} ${props.inputState ? inputStates[props.inputState] : ""} ${props.bordered ? "bordered" : ""} ${!props.inputLabel ? "padded" : ""}`}
                                type={props.type ? props.type : "text"}
                                autoFocus={props.autoFocus ? props.autoFocus : false}
                                disabled={props.disabled || props.inputState === "disabled" ? true : false}
                                style={{ paddingLeft: props.iconLeft ? 50 : 15 }}
                            /> :
                            <InputMask
                                {...props}
                                className={`input-block ${props.className ? props.className : ""} ${props.backgroundColor ? props.backgroundColor : "light--sbg"} ${props.inputState ? inputStates[props.inputState] : ""} ${props.bordered ? "bordered" : ""} ${!props.inputLabel ? "padded" : ""}`}
                                type={props.type ? props.type : "text"}
                                autoFocus={props.autoFocus ? props.autoFocus : false}
                                disabled={props.disabled || props.inputState === "disabled" ? true : false}
                                style={{ paddingLeft: props.iconLeft ? 50 : 15 }}
                            />
                    }

                    <CustomBlock className="icon-right-container" style={{ marginTop: marginTop(), width: props.inputRightButtonText ? 'unset%' : 45 }}>
                        {
                            props.loading ?
                                <AiOutlineLoading
                                    tabIndex="-1"
                                    className="loading-indicator rotating success--clr"
                                    size={22}
                                />
                                :
                                <button
                                    type="button"
                                    tabIndex="-1"
                                    onClick={props.iconRightOnClick ? props.iconRightOnClick : () => { }}
                                >
                                    {props.iconRight}
                                </button>
                        }
                        {
                            props.clearAction &&
                            <button
                                type="button"
                                tabIndex="-1"
                                onClick={props.clearActionOnClick ? props.clearActionOnClick : () => { }}
                            >
                                <CgClose className="mid-grey--clr" size={22} />
                            </button>
                        }

                        {
                            props.inputRightButtonText &&
                                props.to ?
                                <Link
                                    tabIndex="-1"
                                    to={props.to ? props.to : "#"}
                                    onClick={props.inputRightButtonOnClick ? props.inputRightButtonOnClick : () => { }}
                                    className={`input-right-button ${props.inputRightButtonBackgroundColor ? props.inputRightButtonBackgroundColor : "light-grey--sbg"}`}
                                >
                                    {props.inputRightButtonText}
                                </Link>
                                :
                                props.inputRightButtonText &&
                                <button
                                    tabIndex="-1"
                                    onClick={props.inputRightButtonOnClick ? props.inputRightButtonOnClick : () => { }}
                                    className={`input-right-button ${props.inputRightButtonBackgroundColor ? props.inputRightButtonBackgroundColor : "light-grey--sbg"}`}
                                >
                                    {props.inputRightButtonText}
                                </button>
                        }

                    </CustomBlock>
                </CustomBlock>
                {
                    props.inputState === 'error' &&
                    <span className={`input-state-text error-message ${!props.inputLabel || props.label ? "unpadded" : ""}`}>
                        {props.errorMessage ? props.errorMessage : props.inputLabel || props.label ? (props.inputLabel || props.label + " " + errorMessageSuffix) : "Error message undefined"}
                    </span>
                }
                {
                    props.inputState === 'warning' &&
                    <span className={`input-state-text warning-message ${!props.inputLabel || props.label ? "unpadded" : ""}`}>
                        {props.warningMessage}
                    </span>
                }
                {
                    props.inputState === 'success' &&
                    <span className={`input-state-text success-message ${!props.inputLabel || props.label ? "unpadded" : ""}`}>
                        {props.successMessage}
                    </span>
                }
            </CustomBlock>
        </>
    )
}

InputBlock.propTypes = {
    // CONTAINER PROPS
    containerClassName: PropTypes.string,

    // LABEL PROPS
    label: PropTypes.string,
    inputLabel: PropTypes.string,

    // STATE PROPS
    inputState: PropTypes.string,
    errorMessage: PropTypes.string,
    successMessage: PropTypes.string,
    warningMessage: PropTypes.string,

    // INPUT PROPS
    type: PropTypes.string,
    className: PropTypes.string,
    backgroundColor: PropTypes.string,
    placeholder: PropTypes.string,

    // NAVIGATION PROPS
    to: PropTypes.string,

    // ITEMS AND ICON PROPS
    iconLeft: PropTypes.object,
    iconRight: PropTypes.object,
    inputRightButtonText: PropTypes.string,
    inputRightButtonBackgroundColor: PropTypes.string,

    // FUNCTION PROPS
    iconLeftOnClick: PropTypes.func,
    iconRightOnClick: PropTypes.func,
    clearActionOnClick: PropTypes.func,
    inputRightButtonOnClick: PropTypes.func,

    // BOOLEAN PROPS
    isRequired: PropTypes.bool,
    loading: PropTypes.bool,
    clearAction: PropTypes.bool,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    bordered: PropTypes.bool,
}

export default InputBlock;